import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowCirclemin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 28,
		height: 28,
		rx: 14,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.964 13.606 10.92 8.105a.124.124 0 0 0-.201.098v1.208c0 .077.036.15.095.197L16.44 14l-5.625 4.392a.248.248 0 0 0-.095.197v1.208c0 .105.12.162.201.098l7.044-5.501a.5.5 0 0 0 0-.788Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgArrowCirclemin);
export { ForwardRef as ReactComponent };
